const s = {
  name: "Justice",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,1.9-1.3,3.4-3,3.9V12h13.6l5.4,9.7V23c0,3.3-2.7,6-6,6s-6-2.7-6-6
			v-1.3l4.3-7.7H21.2l3.7,24H30v2H10v-2h5.1l3.7-24H7.7l4.3,7.7V23c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6v-1.3L5.4,12H19V7.9
			C17.3,7.4,16,5.9,16,4z M20,2c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2S21.1,2,20,2z M20,19.6L17.2,38h5.7L20,19.6z M9.3,21
			L6,15.1L2.7,21H9.3z M2,23c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4H2z M30.7,21h6.6L34,15.1L30.7,21z M30,23c0,2.2,1.8,4,4,4s4-1.8,4-4
			H30z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Justice
};
